module.exports = __webpack_public_path__ + "static/modal_idcard_front.911d3836.png";